import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IPolygon } from 'src/models/polygon.model';
import services from 'src/services/polygon.service';

export const actionTypes = {
  POLYGON_FETCH: 'POLYGON_FETCH',
  POLYGON_ADD: 'POLYGON_ADD',
  POLYGON_UPDATE: 'POLYGON_UPDATE',
  POLYGON_DELETE: 'POLYGON_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP requests
export const asyncActions = {
  listGET: {
    type: actionTypes.POLYGON_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.POLYGON_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.POLYGON_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.POLYGON_DELETE,
    service: services.itemDELETE,
  },
};

export type IPolygonAsync = typeof asyncActions;

export interface IPolygonState extends ICommonState<IPolygonAsync> {
  data?: IPolygon;
  list: IPolygon[];
  total: number;
}

export const defaultState: IPolygonState = {
  status: {},
  list: [],
  total: 0,
};

const PolygonReducer = (
  state: IPolygonState = defaultState,
  action: IReducerAction<IPolygonAsync>
): IPolygonState => {
  switch (action.type) {
    case actionTypes.POLYGON_FETCH: {
      return {
        ...state,
        list: action.payload?.polygon.rows ?? [],
        total: action.payload?.polygon.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default PolygonReducer;
